import React, { useRef, useMemo, useState, useEffect } from 'react';
import styled from 'styled-components';
import Draggable from 'react-draggable';

export interface PixelWindowProps {
  id?: number;
  title?: string;
  children: React.ReactNode;
  defaultPosition?: { x: number; y: number };
  zIndex?: number;
  onFocus?: () => void;
  onClose?: () => void;
  style?: React.CSSProperties;
}

/** Generic 8-bit draggable window **/
export function PixelWindow({
  title = 'Window',
  children,
  defaultPosition = { x: 100, y: 100 },
  zIndex = 0,
  onFocus = () => { },
  onClose = () => { },
  style = {}
}: PixelWindowProps) {
  const nodeRef = useRef<HTMLDivElement>(null);

  const sprinkles = useMemo(() => {
    const icons = ['/coffeecup.png', '/controller.png'];
    const cols = 5;
    const rows = 6;
    const hSpacing = 80 / (cols - 1);
    const vSpacing = 80 / (rows - 1);
    const list: { key: number; src: string; x: number; y: number; rotation: number }[] = [];
    let idx = 0;
    for (let row = 0; row < rows; row++) {
      for (let col = 0; col < cols; col++) {
        list.push({
          key: idx,
          src: icons[idx % icons.length],
          x: 10 + col * hSpacing,
          y: 10 + row * vSpacing,
          rotation: Math.random() * 60 - 30
        });
        idx++;
      }
    }
    return list;
  }, []);

  return (
    <Draggable handle=".title-bar" defaultPosition={defaultPosition} nodeRef={nodeRef as any} onStart={onFocus}>
      <Wrapper ref={nodeRef} onMouseDown={onFocus} style={{ zIndex, ...style }}>
        {/* <SprinklesContainer>
          {sprinkles.map(s => (
            <Sprinkle
              key={s.key}
              src={s.src}
              style={{ left: `${s.x}%`, top: `${s.y}%`, transform: `rotate(${s.rotation}deg)` }}
            />
          ))}
        </SprinklesContainer> */}

        <TitleBar className="title-bar">
          <TitleText>{title}</TitleText>
          <WindowControls>

            <ControlButton title="Close" onClick={e => { e.stopPropagation(); onClose(); }}>
              ✕
            </ControlButton>
          </WindowControls>
        </TitleBar>

        <Content>{children}</Content>
      </Wrapper>
    </Draggable>
  );
}



const Wrapper = styled.div`
  position: absolute;
  width: 320px;
  border: 3px solid #0DCCFB;
  background-color: #011748;
  font-family: 'ChiKareGo2', monospace;
  box-shadow: 4px 4px #003b4aff;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
`;

const SprinklesContainer = styled.div`
  position: absolute;
  inset: 0;
  pointer-events: none;
  z-index: 0;
`;

const Sprinkle = styled.img`
  position: absolute;
  width: 30px;
  height: 20px;
  opacity: 0.2;
`;

const TitleBar = styled.div`
  position: relative;
  z-index: 1;
  background-color: #01219F;
  border: 3px solid #0DCCFB;
  display: flex;
  justify-content: space-between;
  cursor: move;
  font-size: 0.85rem;
  box-sizing: border-box;
`;

const TitleText = styled.span`
  font-weight: bold;
  color:#00BD48;
  font-size:1rem;

  border-right:3px solid #002457;
 height:100%;
 padding-right:3px;
 padding-left:5px;
`;

const WindowControls = styled.div`
  position: relative;
  z-index: 1;
  display: flex;
  gap: 4px;
`;

const ControlButton = styled.button`
  width: 30px;
  height: 100%;
  border:2px solid #9a8fecff;
  background: #7263DE;
  font-family: inherit;
  font-size: 0.7rem;
  cursor: pointer;
  padding: 0;
  &:hover {
    background: #4032a8ff;
  } 
  color:yellow;
  font-weight:800;
`;

const Content = styled.div`
  position: relative;
  z-index: 1;
  padding: 8px;
  font-size: 0.75rem;
  color:#5fbf9b;
  flex: 1;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  overflow: hidden;
`;


